export enum XpoUploadEventType {
  Add = 'ADD',
  Remove = 'REMOVE',
  Removeall = 'REMOVEALL',
  Unknown = 'UNKNOWN',
}
